/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-10-29 19:16:50
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2022-06-29 15:34:58
 * @Content:
 */

import { Dayjs } from "dayjs";
import { findIndex } from "lodash";
import { TIME_FORMATTER } from "../constants/time";
import { IActivityInfo, IGoal } from "../service/activity/interface";
import {
  IGoalRewardItem,
  IProgressRewardType,
  IRewordList,
} from "../service/Index";
import day from "../utils/day";
import { IGoalCarouselItemState } from "./components/ProgressCard/GoalCarousel/GoalCarouselItem/interface";
import { IActivitySignState, IActivityState } from "./interface";

/**
 * 获取活动的状态
 */
export const getActivityState = (
  activityInfo: IActivityInfo,
  currTime: Dayjs
): IActivityState => {
  const curr = currTime.valueOf();
  const start = day(activityInfo.effect_start, TIME_FORMATTER).valueOf();
  const end = day(activityInfo.effect_end, TIME_FORMATTER).valueOf();
  if (curr < start) {
    // 未开始
    return 0;
  } else if (curr > end) {
    // 已结束
    return 2;
  }
  // 进行中
  return 1;
};

/**
 * 获取活动报名的状态
 */
export const getActivitySignState = (
  activityInfo: IActivityInfo,
  currTime: Dayjs
): IActivitySignState => {
  const curr = currTime.valueOf();
  const start = day(activityInfo.enter_start, TIME_FORMATTER).valueOf();
  const end = day(activityInfo.enter_end, TIME_FORMATTER).valueOf();
  if (curr < start) {
    // 报名未开始
    return 0;
  } else if (curr > end) {
    // 报名已结束
    return 2;
  }
  // 报名进行中
  return 1;
};

/**
 * 获取目标的状态
 */
export const getGoalState = (
  goal: IGoal,
  currTime: Dayjs
): IGoalCarouselItemState => {
  const curr = currTime.valueOf();
  const start = day(goal.limit_start, TIME_FORMATTER).valueOf();
  const end = day(goal.limit_end, TIME_FORMATTER).valueOf();
  if (goal.progress == 100) {
    // 已完成
    return 2;
  }
  if (curr > end) {
    // 已结束，未完成
    return 3;
  }
  if (start <= curr && curr <= end) {
    // 已开始，可以去完成
    return 1;
  }
  // 未开始
  return 0;
};

/**
 * 获取 活动模板 进行页 的奖励展示类型配置
 */
export const getProgressRewardType = (
  progressRewardConfig: IRewordList
): IProgressRewardType | "none" => {
  if (
    progressRewardConfig &&
    progressRewardConfig.reward_type &&
    progressRewardConfig.show
  ) {
    return progressRewardConfig.reward_type;
  }
  return "none";
};

export const recordSc = (options: any) => {
  try {
    lib.cpm.recordSc && lib.cpm.recordSc(options);
  } catch (err) {
    console.log(JSON.stringify(err));
  }
};

/* 活动详情：是否为“完成单个目标的”的活动 */
export const checkIsFinishOneGoal = (activityDetail: IActivityInfo) => {
  if (activityDetail) {
    return activityDetail.enter_type === 1;
  }
  return false;
};

/* 活动详情：阶段 */
export const getGoals = (activityDetail: IActivityInfo) => {
  return activityDetail?.goals || [];
};

/**
 * “单一目标活动”
 * 找到报名的是哪个目标
 */
export const findMyGoal = (goals: IGoal[]) => {
  const index = findIndex(goals, (goal) => {
    return goal.entered === 1;
  });
  if (index !== -1) {
    return goals[index];
  } else {
    return null;
  }
};
/* 找到目标 在模板里对应的 配置 */
export const findTempGoalConf = (
  goal_reward_list: IGoalRewardItem[],
  myGoal: IGoal | null
) => {
  const index = findIndex(goal_reward_list, (goalConf) => {
    return goalConf.goal_id === myGoal?.goal_id;
  });
  if (index !== -1) {
    return goal_reward_list[index];
  } else {
    return null;
  }
};

/**
 * 在跳转链接中，拼上 userid
 * 逻辑：
 * 识别到 链接中有 userid= 部分，且后面为空，就自动加上
 */
export const fillUserIdInUrl = (url: string, userid: string) => {
  /**
   * 举几种需要补 userid 的 url 情况：
   * 1. userid 并不直接是链接的参数：https://www.codoon.com/weixinminiprogram?username=gh_5c9b3785d108&path=pages/iH7tCbKV/index?userid=
   * 2. userid 直接是链接的参数：https://xxx?userid=&其它参数#/xxx
   */

  let fillUrl = url;

  /* 找到 {?|& 开始}userid= 这样的位置（不可能是第1位） */
  const USER_ID_REG = /[\?&]userid=/;
  const userIdMatch = url.match(USER_ID_REG);
  if (userIdMatch) {
    const startIndex = userIdMatch.index || 0;
    const endIndex = startIndex + "&userid=".length;
    // 看结尾的字符是不是真的结束了
    if (["&", "#", undefined].indexOf(url[endIndex]) !== -1) {
      // 即找到了一个空的 userid= 部分，填入userid
      fillUrl =
        url.slice(0, endIndex) + userid + url.slice(endIndex, url.length);
    }
  }

  return fillUrl;
};
